module.exports = __webpack_public_path__ + "static/4-8a7e022156e22dcb704d0266cd38aac0.jpg";